import React, { useEffect, useState } from 'react'
import { Alert } from 'react-bootstrap'
import * as s from './PreseasonCountdown.scss'
import moment from 'moment-timezone'

const unitLabel = (value, unit) => Number(value) === 1 ? unit : `${unit}s`

const PreseasonCountdown = ({ nflKickoff = '', prefix = '', smallPrefix = '', elapsed = '' }) => {

    const [countdown, setCountdown] = useState({})
    const [isElapsed, setElapsed] = useState(false)
    const [initialLoad, setInitialLoad] = useState(false)

    useEffect(() => {
        updateCountdown()
        const timerId = setInterval(() => updateCountdown(), 1000)
        return () => clearInterval(timerId)
    }, [nflKickoff])

    const updateCountdown = () => {
        if (nflKickoff && moment(nflKickoff).isValid()) {
            var kickoff = moment(nflKickoff)
            const duration = moment.duration(kickoff.diff(moment()))
            setInitialLoad(true)
            setElapsed(duration._milliseconds <= 0)
            setCountdown(duration._data)
        }
    }

    if (!initialLoad) return null
    return (
        <div className={s.container}>
        {!isElapsed ?
            <section className={s.panel} aria-label='NFL kickoff countdown'>
            {countdown ?
            <>
            <header className={s.header}>
                <div className={s.eyebrow}>Kickoff countdown</div>
                {prefix ? <h2 className={s.prefix}>{prefix}</h2> : null}
                {smallPrefix ? <h2 className={s.smallPrefix}>{smallPrefix}</h2> : null}
            </header>
            <div className={s.content} role='timer'>
                    {countdown.years ? <div className={s.item}><div className={s.data}>{countdown.years}</div><div className={s.heading}>{unitLabel(countdown.years, 'Year')}</div></div>: null}
                    {countdown.months ? <div className={s.item}><div className={s.data}>{countdown.months}</div><div className={s.heading}>{unitLabel(countdown.months, 'Month')}</div></div>: null}
                    <div className={s.item}><div className={s.data}>{countdown.days || 0}</div><div className={s.heading}>{unitLabel(countdown.days || 0, 'Day')}</div></div>
                    <div className={s.item}><div className={s.data}>{countdown.hours}</div><div className={s.heading}>{unitLabel(countdown.hours, 'Hour')}</div></div>
                    <div className={s.item}><div className={s.data}>{countdown.minutes}</div><div className={s.heading}>{unitLabel(countdown.minutes, 'Minute')}</div></div>
                    <div className={s.item}><div className={s.data}>{countdown.seconds}</div><div className={s.heading}>{unitLabel(countdown.seconds, 'Second')}</div></div>
            </div>
            </>
            : null}
            </section>
        : <Alert variant='success' className={s.alertDefault}>{elapsed}</Alert>}            
        </div>
    )
}

export default PreseasonCountdown
